import { Stack } from "../../components";
import { UiStackModel } from "../../models";
import { renderViewModels } from "../../render-view-model";

export type UiStackProps = {
    readonly model: UiStackModel;
};

const UiStack = ({
    model: {
        content: { orientation, children, spacing, fullHeight }
    }
}: UiStackProps) => {
    return (
        <Stack
            data-testid="stack"
            orientation={orientation}
            spacing={spacing}
            fullHeight={fullHeight}
        >
            {children && renderViewModels(children)}
        </Stack>
    );
};

export default UiStack;
